export const siteSettings = {
  defaultLanguage: "en",
  site_header: {
    menu: [
      {
        id: 1,
        label: "Home",
        path: "/",
      },
      {
        id: 2,
        label: "About Us",
        path: "/about-us",
      },
      {
        id: 3,
        label: "Our products",
        path: "/our-products",
      },
      {
        id: 4,
        label: "Our Services",
        path: "/our-services",
      },
      {
        id: 5,
        label: "Our Clients",
        path: "/our-clients",
      },
      {
        id: 6,
        label: "FAQs",
        path: "/faqs",
      },
    ],
  },
};
